import React from 'react';

export function InvoicesColumnFormatter(cellContent) {
  return (
    <>
      <div className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
        {cellContent.count}
      </div>
      <div className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
        {Boolean(cellContent.total) ? parseFloat(cellContent.total).toFixed(2) : '0.00'}
      </div>
    </>
  );
}
